var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 5.5,
    stroke: "#060606",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.625 22.0833L34.1265 19.3332C34.3107 19.2411 34.5154 19.1977 34.721 19.207C34.9267 19.2162 35.1266 19.2779 35.3018 19.3861C35.4769 19.4943 35.6215 19.6455 35.7219 19.8253C35.8222 20.0051 35.8749 20.2075 35.875 20.4134V28.5866C35.8749 28.7925 35.8222 28.9949 35.7219 29.1747C35.6215 29.3545 35.4769 29.5057 35.3018 29.6139C35.1266 29.7221 34.9267 29.7838 34.721 29.793C34.5154 29.8023 34.3107 29.7589 34.1265 29.6668L28.625 26.9167V22.0833ZM14.125 19.6667C14.125 19.0257 14.3796 18.411 14.8328 17.9578C15.286 17.5046 15.9007 17.25 16.5417 17.25H26.2083C26.8493 17.25 27.464 17.5046 27.9172 17.9578C28.3704 18.411 28.625 19.0257 28.625 19.6667V29.3333C28.625 29.9743 28.3704 30.589 27.9172 31.0422C27.464 31.4954 26.8493 31.75 26.2083 31.75H16.5417C15.9007 31.75 15.286 31.4954 14.8328 31.0422C14.3796 30.589 14.125 29.9743 14.125 29.3333V19.6667Z",
    stroke: "#212121",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.591aa8bd38413c53bd42c2190ecea94d.svg";
export { ForwardRef as ReactComponent };